export const WEEK_DAY_HOUR_HEIGHT = 200;